import { BrokerExtensions } from "@primaria/plugins-core";
import { BrokerDisposableHandler } from "@uxland/primary-shell";
import { SetCustomFilterGroup } from "./request";
import { SetCustomFilterGroupHandler } from "./handler";

let request: BrokerDisposableHandler;

export const bootstrapSetCustomFilterGroup = (broker: BrokerExtensions) => {
  request = broker.registerRequest(SetCustomFilterGroup, SetCustomFilterGroupHandler);
};

export const teardownSetCustomFilterGroup = () => {
  request?.dispose();
};
